import { useOrgStore } from '@/stores/org-store';

/**
 * Prepends `/o/{orgId}` to a path. Reads from org store if orgId not provided.
 * Use outside React components (event handlers, window.open, etc.).
 */
export const orgPath = (path: string, orgId?: string): string => {
  const id = orgId ?? useOrgStore.getState().currentOrg?.orgid;
  if (!id) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `/o/${id}${normalizedPath}`;
};

/**
 * Extracts orgId from a path that starts with `/o/:orgId/...`.
 * Returns null if path doesn't match the org pattern.
 */
export const extractOrgFromPath = (
  pathname: string,
): { orgId: string; remainingPath: string } | null => {
  const match = pathname.match(/^\/o\/([^/]+)(\/.*)?$/);
  if (!match) return null;
  return {
    orgId: match[1],
    remainingPath: match[2] || '/',
  };
};

/**
 * Strips the `/o/:orgId` prefix from a path.
 * Returns the original path if no prefix is present.
 */
export const stripOrgPrefix = (pathname: string): string => {
  const extracted = extractOrgFromPath(pathname);
  return extracted ? extracted.remainingPath : pathname;
};
